import validate from "C:/vnimpex/tcms-framework-test-3001/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "C:/vnimpex/tcms-framework-test-3001/middleware/auth.global.ts";
import manifest_45route_45rule from "C:/vnimpex/tcms-framework-test-3001/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}